import React, {HTMLAttributes} from 'react'
import {names} from 'shared/lib'
import styles from './styles.module.scss'

type RadioButtonProps = {
  checked?: boolean
  name: string
} & HTMLAttributes<HTMLInputElement>

export const RadioButton: React.FC<RadioButtonProps> = ({className, ...props}) => {
  return (
    <div className={names(styles.radio, props.checked && styles.checked, className) }>
      <input {...props} type='radio' readOnly className={styles.input} />
      {props.checked ? <div className={styles.checkmark} /> : null}
    </div>
  )
}